import { Stack } from '@mantine/core';
import { usePresetContext } from '../contexts/PresetContext';
import { OperationCard } from './OperationCard';
import { useNavigationContext } from '../contexts/NavigationContext';
import { topLevelElements as operations } from '../constants/schema';

export const SchemaTopNavigationList = () => {
  const { formData } = usePresetContext();
  const { setSelectedTopNavigation, selectedTopNavigation } = useNavigationContext();

  return (
    <Stack pb='sm'>
      {operations.map((operation) => (
        <OperationCard
          key={operation.name}
          name={operation.label}
          path={operation.name}
          description={operation.description}
          onClick={() => {
            setSelectedTopNavigation(operation.name);
          }}
          isSelected={selectedTopNavigation === operation.name}
          isEnabled={formData[operation.name] !== undefined}
        />
      ))}
    </Stack>
  );
};
